<template>
    <div>
        <my-header title="设置" :is-back="true"/>
        <div class="btn-wrap">
            <van-button round @click="logout"
                        type="danger" size="large">退出登录</van-button>
        </div>
    </div>
</template>

<script>
import MyHeader from "@/components/myHeader";
import {Toast} from "vant";
export default {
    name: "MySetting",
    components:{MyHeader},
    methods:{
        // 登出
        logout(){
            localStorage.removeItem('token')
            Toast.success('退出登录成功!');
            setTimeout(() => {
                this.$router.replace('/login')
            }, 1000);
        }
    }
}
</script>

<style scoped>
.btn-wrap{
    margin:20vw 5vw;
}
</style>
